module.exports = __webpack_public_path__ + "img/main_back.3916f1eb.png";